import AndieGenericToolRender from './AndieGenericToolRender';
import { useTranslation } from 'react-i18next';
import { ActionRenderAi } from '@/ai/types/action-render-ai';
import { NearMeRounded } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { useEffect, useRef } from 'react';
import { ActionResponseStatusAi } from '@/ai/enum/action-response-status-ai';
import { useAndieChatControls } from '@/providers/andie-chat-provider';

type ActionResponse = { routePath: string; navigated: boolean };
type ActionArgs = { routePath: string };

export type AndieNavigateToRouteProps = ActionRenderAi<ActionResponse, ActionArgs>;

const AndieNavigateToRoute = (props: AndieNavigateToRouteProps) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { agentNavigationPendingRef } = useAndieChatControls();
    const executingSteps = useRef<number>(0);

    useEffect(() => {
        if (props.status === ActionResponseStatusAi.EXECUTING) {
            executingSteps.current += 1;
        }

        if (
            props.status === ActionResponseStatusAi.COMPLETE &&
            props.args?.routePath &&
            executingSteps.current > 0
        ) {
            agentNavigationPendingRef.current = true;
            navigate(props.args?.routePath);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.status]);

    return (
        <AndieGenericToolRender<ActionResponse, ActionArgs>
            title={() => t('andie.tool.navigate-to-route.title')}
            icon={<NearMeRounded fontSize="small" />}
            loadingMessages={(args) => [
                t('andie.tool.navigate-to-route.loading', { route: args?.routePath || '' }),
            ]}
            completeMessage={({ args }) =>
                t('andie.tool.navigate-to-route.complete', { route: args?.routePath || '' })
            }
            {...props}
        />
    );
};

export default AndieNavigateToRoute;
